// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Lato:wght@400;500);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.IbyTgxPWLb9n5yHZVWzi {
  width: 100%;
}
.IbyTgxPWLb9n5yHZVWzi .mYb5WCtxiK4eAYfcC3OB {
  display: flex;
  align-items: center;
  gap: 12px;
}
.IbyTgxPWLb9n5yHZVWzi .mYb5WCtxiK4eAYfcC3OB .qvZMnl2KSD0R_gn2mFmo {
  font-size: 16px;
  color: #b6b6b6;
}
.IbyTgxPWLb9n5yHZVWzi .mYb5WCtxiK4eAYfcC3OB .F72Dq5YoS35NWcLeAt_s {
  font-size: 18px;
  font-weight: 500;
  color: #fff;
}
.IbyTgxPWLb9n5yHZVWzi .mYb5WCtxiK4eAYfcC3OB .KGAMXGVSaN_STUu7_ao7 {
  padding: 4px 12px !important;
  font-size: 14px;
  color: #774dee !important;
  border: 1px solid #774dee !important;
  border-radius: 8px;
  background: none;
}
.IbyTgxPWLb9n5yHZVWzi .mYb5WCtxiK4eAYfcC3OB .KGAMXGVSaN_STUu7_ao7:hover {
  background-color: rgba(119, 77, 238, 0.1);
}
.IbyTgxPWLb9n5yHZVWzi .vAzRWnZiUW3TJ213CIJX {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.IbyTgxPWLb9n5yHZVWzi .vAzRWnZiUW3TJ213CIJX .gAWhGABzx4joY93_OxN4 {
  display: flex;
  align-items: center;
  position: relative;
}
.IbyTgxPWLb9n5yHZVWzi .vAzRWnZiUW3TJ213CIJX .gAWhGABzx4joY93_OxN4 .jUqHXsBNvLDelWrzx45p {
  position: absolute;
  left: 12px;
  font-size: 18px;
  color: #b6b6b6;
}
.IbyTgxPWLb9n5yHZVWzi .vAzRWnZiUW3TJ213CIJX .gAWhGABzx4joY93_OxN4 .gFrwScPmdfUEIIJ_39ji {
  flex: 1;
  padding: 8px 12px 8px 32px;
  font-size: 18px;
  background-color: rgba(255, 255, 255, 0.1);
  border: 1px solid #dbdbdb;
  border-radius: 8px;
  color: #fff;
}
.IbyTgxPWLb9n5yHZVWzi .vAzRWnZiUW3TJ213CIJX .gAWhGABzx4joY93_OxN4 .gFrwScPmdfUEIIJ_39ji:focus {
  outline: none;
  border-color: #774dee;
  background-color: rgba(255, 255, 255, 0.15);
}
.IbyTgxPWLb9n5yHZVWzi .vAzRWnZiUW3TJ213CIJX .gAWhGABzx4joY93_OxN4 .Ld6LQRhtmbi7gqeZijp_ {
  position: absolute;
  right: 12px;
  width: 20px;
  height: 20px;
  animation: ftFe4GdktehsfaPVV2Xq 1s linear infinite;
}
.IbyTgxPWLb9n5yHZVWzi .vAzRWnZiUW3TJ213CIJX .EJ_byP7pJKmYwV9VwM3p {
  font-size: 14px;
  padding: 4px 8px;
  border-radius: 4px;
}
.IbyTgxPWLb9n5yHZVWzi .vAzRWnZiUW3TJ213CIJX .EJ_byP7pJKmYwV9VwM3p.JzOrhFshxwFO4dd2xx8m {
  color: #4caf50;
  background-color: rgba(76, 175, 80, 0.1);
}
.IbyTgxPWLb9n5yHZVWzi .vAzRWnZiUW3TJ213CIJX .EJ_byP7pJKmYwV9VwM3p.c5gKU2M5leNGQm5NxAL1 {
  color: #f44336;
  background-color: rgba(244, 67, 54, 0.1);
}
.IbyTgxPWLb9n5yHZVWzi .vAzRWnZiUW3TJ213CIJX .Plwase9Q530pEy4LdAZl {
  display: flex;
  gap: 8px;
  justify-content: flex-end;
  margin-top: 8px;
}
.IbyTgxPWLb9n5yHZVWzi .vAzRWnZiUW3TJ213CIJX .Plwase9Q530pEy4LdAZl button {
  padding: 6px 16px !important;
  font-size: 14px;
  border-radius: 8px;
}
.IbyTgxPWLb9n5yHZVWzi .vAzRWnZiUW3TJ213CIJX .Plwase9Q530pEy4LdAZl button:first-child {
  background: none;
  color: #b6b6b6 !important;
  border: 1px solid #dbdbdb !important;
}
.IbyTgxPWLb9n5yHZVWzi .vAzRWnZiUW3TJ213CIJX .Plwase9Q530pEy4LdAZl button:last-child {
  background-color: #774dee !important;
  color: #fff !important;
  border: none !important;
}
.IbyTgxPWLb9n5yHZVWzi .vAzRWnZiUW3TJ213CIJX .Plwase9Q530pEy4LdAZl button:last-child:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
.IbyTgxPWLb9n5yHZVWzi .vAzRWnZiUW3TJ213CIJX .Plwase9Q530pEy4LdAZl .e5fnjfpJhuHXjDAkpamg {
  width: 16px;
  height: 16px;
  animation: ftFe4GdktehsfaPVV2Xq 1s linear infinite;
}

@keyframes ftFe4GdktehsfaPVV2Xq {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}`, "",{"version":3,"sources":["webpack://./src/editor/components/elements/UsernameEditor/UsernameEditor.module.scss","webpack://./src/editor/style/variables.scss"],"names":[],"mappings":"AAEA;EACE,WAAA;AAAF;AAEE;EACE,aAAA;EACA,mBAAA;EACA,SAAA;AAAJ;AAEI;EACE,eAAA;EACA,cCWU;ADXhB;AAGI;EACE,eAAA;EACA,gBAAA;EACA,WAAA;AADN;AAII;EACE,4BAAA;EACA,eAAA;EACA,yBAAA;EACA,oCAAA;EACA,kBAAA;EACA,gBAAA;AAFN;AAIM;EACE,yCAAA;AAFR;AAOE;EACE,aAAA;EACA,sBAAA;EACA,QAAA;AALJ;AAOI;EACE,aAAA;EACA,mBAAA;EACA,kBAAA;AALN;AAOM;EACE,kBAAA;EACA,UAAA;EACA,eAAA;EACA,cC1BQ;ADqBhB;AAQM;EACE,OAAA;EACA,0BAAA;EACA,eAAA;EACA,0CAAA;EACA,yBAAA;EACA,kBAAA;EACA,WCzCA;ADmCR;AAQQ;EACE,aAAA;EACA,qBC3DD;ED4DC,2CAAA;AANV;AAUM;EACE,kBAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,kDAAA;AARR;AAYI;EACE,eAAA;EACA,gBAAA;EACA,kBAAA;AAVN;AAYM;EACE,cAAA;EACA,wCAAA;AAVR;AAaM;EACE,cAAA;EACA,wCAAA;AAXR;AAeI;EACE,aAAA;EACA,QAAA;EACA,yBAAA;EACA,eAAA;AAbN;AAeM;EACE,4BAAA;EACA,eAAA;EACA,kBAAA;AAbR;AAeQ;EACE,gBAAA;EACA,yBAAA;EACA,oCAAA;AAbV;AAgBQ;EACE,oCAAA;EACA,sBAAA;EACA,uBAAA;AAdV;AAgBU;EACE,YAAA;EACA,mBAAA;AAdZ;AAmBM;EACE,WAAA;EACA,YAAA;EACA,kDAAA;AAjBR;;AAuBA;EACE;IACE,uBAAA;EApBF;EAsBA;IACE,yBAAA;EApBF;AACF","sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"usernameEditor": `IbyTgxPWLb9n5yHZVWzi`,
	"display": `mYb5WCtxiK4eAYfcC3OB`,
	"label": `qvZMnl2KSD0R_gn2mFmo`,
	"username": `F72Dq5YoS35NWcLeAt_s`,
	"editButton": `KGAMXGVSaN_STUu7_ao7`,
	"editor": `vAzRWnZiUW3TJ213CIJX`,
	"inputWrapper": `gAWhGABzx4joY93_OxN4`,
	"prefix": `jUqHXsBNvLDelWrzx45p`,
	"input": `gFrwScPmdfUEIIJ_39ji`,
	"loader": `Ld6LQRhtmbi7gqeZijp_`,
	"spin": `ftFe4GdktehsfaPVV2Xq`,
	"validation": `EJ_byP7pJKmYwV9VwM3p`,
	"valid": `JzOrhFshxwFO4dd2xx8m`,
	"invalid": `c5gKU2M5leNGQm5NxAL1`,
	"actions": `Plwase9Q530pEy4LdAZl`,
	"buttonLoader": `e5fnjfpJhuHXjDAkpamg`
};
export default ___CSS_LOADER_EXPORT___;
